import { getStoredCountryCode, storeCountryCode } from "./countryStorage";

export const clearLocalSession = (): void => {
  const selectedCountryCode = getStoredCountryCode();
  localStorage.clear();
  storeCountryCode(selectedCountryCode);
};
